import { notEmpty } from '@festina-life/core'
import { jwtDecode } from 'jwt-decode'
import { useMemo } from 'react'

import { useMsal } from './useMsal/useMsal'

export type Personas =
  | 'Consultant'
  | 'FrontOffice'
  | 'BackOfficeBuildUp'
  | 'BackOfficePayments'
  | 'BackOfficeCombi'
  | 'Admin'
  | 'Expert'
  // oxlint-disable-next-line ban-types
  | (string & {})

const getPersonaRoles = <T>(roles: (string | undefined)[] | undefined) =>
  roles
    ?.filter(notEmpty)
    .filter((role) => role.endsWith('.P'))
    .map((personaRoles) => personaRoles.replace('.P', '') as T) ?? []

export const useAvailablePersonas = <T extends Personas>() => {
  const { accounts } = useMsal()

  return useMemo(() => {
    const decodedAccountRoles = accounts.flatMap(({ idToken }) => {
      try {
        if (!idToken) {
          return []
        }
        return jwtDecode<{ roles?: string[] }>(idToken).roles ?? []
      } catch {
        return []
      }
    })

    return [...new Set(getPersonaRoles<T>(decodedAccountRoles))]
  }, [accounts])
}
